import React, { useEffect, useContext } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import Utils from "../../../Common/Utils";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { VMContext } from "./vmContext";
import Bootbox from "../../../Common/BootBoxManager";

function QuerySetRelease(props) {
  let VMContextdata = useContext(VMContext);
  var [vquerySet, setvquerySet] = React.useState({});
  var [serverList, setServerList] = React.useState([]);
  var [loading, setLoading] = React.useState(false);
  var [loadingServerList, setLoadingServerList] = React.useState(false);

  async function LoadQuerySet(setid) {
    setLoading(true);
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      api_base_url + "versionmanagement/queryset/list/" + setid,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      await setvquerySet((n) => ret.data.data);
      // LoadServerList();
    }
    setLoading(false);
  }

  async function LoadServerList() {
    setLoadingServerList(true);
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      api_base_url + "dbpromoter/server/list/" + vquerySet.uid,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      await setServerList(ret.data.data);
    }
    setLoadingServerList(false);
  }

  function get_data_from_date(dt, ret = "date") {
    if (Utils.isUndefinedOrNull(dt)) return null;
    var ss = dt.split("T");
    if (ret === "date") return ss[0];
    else {
      var tt = ss[1].split(".");
      return tt[0];
    }
  }

  async function deploy(server) {
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let res = await ServiceWrapper.doPost(
      api_base_url + "versionmanagement/queryset/deploy/" + vquerySet.uid,
      {
        name: "VM Deployment: " + vquerySet.name + " to " + server.name,
        serverid: server.id,
      },
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
    } else {
    }
  }

  useEffect(() => {
    if (!Utils.isUndefinedOrNull(vquerySet.uid)) LoadServerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vquerySet]);

  useEffect(() => {
    if (!Utils.isUndefinedOrNull(VMContextdata.currentRealeasingSetId))
      LoadQuerySet(VMContextdata.currentRealeasingSetId);
  }, [VMContextdata.currentRealeasingSetId]);

  return (
    <React.Fragment>
      {loading && (
        <div>
          <div className="p-2 bg-white alert alert-primary small" role="alert">
            <span className="fas fa-circle-notch fa-spin" />
            &nbsp;
            <strong>Loading Query Set</strong>
          </div>
        </div>
      )}
      {!loading && (
        <>
          <div className="row">
            <strong>Query Set Information</strong>
          </div>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>From</th>
                <th>To</th>
                <th>Queries</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>{vquerySet.name}</th>
                <td>
                  {get_data_from_date(vquerySet.start_date)}
                  &nbsp;
                  <small className="text-muted">
                    <strong>
                      {get_data_from_date(vquerySet.start_date, "time")}
                    </strong>
                  </small>
                </td>
                <td>
                  {get_data_from_date(vquerySet.end_date)}
                  &nbsp;
                  <small className="text-muted">
                    <strong>
                      {get_data_from_date(vquerySet.end_date, "time")}
                    </strong>
                  </small>
                </td>
                <td>
                  <span className="badge bg-info text-dark">
                    {vquerySet.query_count}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          {loadingServerList && (
            <div>
              <div
                className="p-2 bg-white alert alert-primary small"
                role="alert"
              >
                <span className="fas fa-circle-notch fa-spin" />
                &nbsp;
                <strong>Loading Server list</strong>
              </div>
            </div>
          )}
          {!loadingServerList && (
            <>
              <div className="row">&nbsp;</div>
              <div>
                <span className="floar-start">
                  <strong>List of servers</strong>
                </span>

                <span className="float-end">
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    style={{ color: "#00A2E5" }}
                    onClick={() => LoadServerList()}
                  >
                    <i className="fa fa-sync-alt" />
                  </button>
                </span>
              </div>
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th width="30%">Progress</th>

                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  {serverList.map((item) => (
                    <tr key={"sams_server_" + item.id}>
                      <td>
                        {item.name}
                        <br />
                        <strong>{item.server_ip}</strong>
                      </td>

                      <td>
                        <strong>{item.status}</strong>
                        <br />
                        {!Utils.isUndefinedOrNull(item.status) && (
                          <div className="progress">
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{ width: item.status_percentage + "%" }}
                              aria-valuenow={item.status_percentage}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              {item.status_percentage}%
                            </div>
                          </div>
                        )}
                      </td>

                      <td>
                        <button
                          disabled={
                            !Utils.isUndefinedOrNull(item.status) &&
                            item.status !== "failed" &&
                            item.status !== "incomplete"
                          }
                          onClick={() =>
                            Bootbox.confirm(
                              "Deploy '" +
                                vquerySet.name +
                                "' Query Set to " +
                                item.name +
                                " ?",
                              `Do you really want to deploy the set <strong>${vquerySet.name}</strong> Query Set to <strong>${item.name}</strong> ? This cannot be undone.`,
                              false,
                              [deploy, item]
                            )
                          }
                          type="button"
                          className="btn btn-sm btn-info"
                        >
                          Deploy
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </>
      )}
    </React.Fragment>
  );
}

export default QuerySetRelease;
